import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminUsersUserRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ user_id }) {
    const { content } = await this.store.request(findRecord('user', user_id));

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
